import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getSpidLoginUrl } from '../services/operatoreAuthApi';
import { MdBusiness, MdSecurity, MdArrowBack } from 'react-icons/md';

function SpidLogo() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
      <circle cx="12" cy="12" r="10" fill="#0066CC"/>
      <text x="12" y="16" textAnchor="middle" fill="white" fontSize="10" fontWeight="bold">S</text>
    </svg>
  );
}

export default function OperatoreRegistrazione() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg w-full max-w-md p-8">

        {/* Header */}
        <div className="flex flex-col items-center mb-8">
          <div className="w-16 h-16 rounded-2xl bg-blue-100 dark:bg-blue-900 flex items-center justify-center text-blue-600 dark:text-blue-300 mb-4">
            <MdBusiness size={32} />
          </div>
          <h1 className="text-2xl font-bold text-gray-800 dark:text-white text-center">
            Registra la tua azienda
          </h1>
          <p className="text-gray-500 dark:text-gray-400 text-sm text-center mt-2">
            Per presentare proposte PPP devi accedere con SPID o CIE.
            Al primo accesso potrai creare il profilo della tua azienda.
          </p>
        </div>

        {/* Come funziona */}
        <div className="bg-gray-50 dark:bg-gray-700/50 rounded-xl p-4 mb-6 space-y-3">
          <p className="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">Come funziona</p>
          {[
            { n: '1', testo: 'Accedi con SPID o CIE' },
            { n: '2', testo: 'Crea il profilo della tua azienda' },
            { n: '3', testo: 'Inizia a presentare proposte PPP' },
          ].map(({ n, testo }) => (
            <div key={n} className="flex items-center gap-3">
              <span className="w-6 h-6 rounded-full bg-blue-100 dark:bg-blue-900 text-blue-600 dark:text-blue-300 text-xs font-bold flex items-center justify-center flex-shrink-0">
                {n}
              </span>
              <span className="text-sm text-gray-700 dark:text-gray-300">{testo}</span>
            </div>
          ))}
        </div>

        {/* Nota sicurezza */}
        <div className="flex items-start gap-2 bg-green-50 dark:bg-green-900/20 rounded-xl p-4 mb-6 border border-green-100 dark:border-green-800">
          <MdSecurity className="text-green-600 dark:text-green-400 flex-shrink-0 mt-0.5" size={18} />
          <p className="text-xs text-green-700 dark:text-green-400">
            L'accesso tramite SPID o CIE garantisce l'identificazione certa della persona fisica,
            come richiesto dall'art. 193 del D.lgs 36/2023.
          </p>
        </div>

        {/* CTA SPID */}
        <button
          onClick={() => window.location.href = getSpidLoginUrl()}
          className="w-full flex items-center justify-center gap-3 px-4 py-3 rounded-lg border-2 border-[#0066CC] bg-white hover:bg-blue-50 transition-colors font-semibold text-[#0066CC] text-sm mb-3"
        >
          <SpidLogo />
          Accedi e registrati con SPID
        </button>

        {/* Torna al login */}
        <button
          onClick={() => navigate('/login?tab=operatore')}
          className="w-full flex items-center justify-center gap-2 text-sm text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 transition-colors"
        >
          <MdArrowBack size={16} /> Torna al login
        </button>

      </div>
    </div>
  );
}
